<template>
  <nav class="navbar navbar-expand-lg navbar-dark axion-navbar">
    <div class="container">
      <!-- Logo -->
      <router-link class="navbar-brand fw-bold glow-text" to="/">
        <i class="bi bi-atom me-2 text-pink"></i>
        Axion Academy
      </router-link>

      <!-- Mobile Toggle -->
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <!-- Menu -->
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav ms-auto">
          <li class="nav-item">
            <a
              class="nav-link"
              href="#"
              data-bs-toggle="modal"
              data-bs-target="#loginModal"
            >
              Login
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>

  <LoginModal />
</template>

<script setup>
import LoginModal from "./LoginModal.vue";
</script>
